import { useQuery } from '@tanstack/react-query';
import type {
  ProductSkuListQuery,
  ProductSkuListResponse,
} from '@produzionejb/types';
import { api } from './api-client';

const QK = {
  list: (q: Partial<ProductSkuListQuery>) => ['product-skus', 'list', q] as const,
};

function toQueryString(q: Partial<ProductSkuListQuery>): string {
  const params = new URLSearchParams();
  if (q.productId) params.set('productId', q.productId);
  if (q.grammatura) params.set('grammatura', String(q.grammatura));
  if (q.sku) params.set('sku', q.sku);
  if (q.active !== undefined) params.set('active', String(q.active));
  const s = params.toString();
  return s ? `?${s}` : '';
}

export function useProductSkus(query: Partial<ProductSkuListQuery>, enabled = true) {
  return useQuery({
    queryKey: QK.list(query),
    queryFn: () =>
      api<ProductSkuListResponse>(`/api/product-skus${toQueryString(query)}`),
    staleTime: 60_000,
    enabled,
  });
}
